// ─── FX Vendors ─────────────────────────────────────────────────────
export const FX_VENDOR_OPTIONS = [
  { value: 'reuters', label: 'Reuters' },
  { value: 'bloomberg', label: 'Bloomberg' },
  { value: 'ecb', label: 'ECB' },
  { value: 'oanda', label: 'OANDA' },
  { value: 'xe', label: 'XE' },
] as const

// ─── Default Markup Options ─────────────────────────────────────────
export const MARKUP_OPTIONS = [
  { value: '0.5', label: '0.5%' },
  { value: '1.0', label: '1.0%' },
  { value: '1.5', label: '1.5%' },
  { value: '2.0', label: '2.0%' },
  { value: '2.5', label: '2.5%' },
  { value: '3.0', label: '3.0%' },
] as const

// ─── Currencies ─────────────────────────────────────────────────────
export const FX_CURRENCIES = [
  { value: 'EUR', label: 'EUR' },
  { value: 'USD', label: 'USD' },
  { value: 'GBP', label: 'GBP' },
  { value: 'BGN', label: 'BGN' },
  { value: 'PLZ', label: 'PLZ' },
  { value: 'RUB', label: 'RUB' },
  { value: 'DHS', label: 'DHS' },
  { value: 'XYZ', label: 'XYZ' },
  { value: 'EAD', label: 'EAD' },
  { value: 'CHF', label: 'CHF' },
  { value: 'JPY', label: 'JPY' },
  { value: 'CAD', label: 'CAD' },
  { value: 'AUD', label: 'AUD' },
  { value: 'BRL', label: 'BRL' },
] as const

// ─── Programs (reused from velocity) ────────────────────────────────
export const FX_PROGRAM_OPTIONS = [
  { value: 'paylink_eu', label: 'PayLink EU' },
  { value: 'fincore_us', label: 'FinCore US' },
  { value: 'payworld_pk', label: 'PayWorld PK' },
  { value: 'merchant_direct', label: 'Merchant Direct' },
] as const

// ─── Rate Source Options ────────────────────────────────────────────
export const RATE_SOURCE_OPTIONS = [
  { value: 'provider', label: 'FX Provider', description: 'Rates sourced automatically from selected vendor' },
  { value: 'manual', label: 'Manual Entry', description: 'Manually enter currency pair rates and markups' },
] as const

// ─── End Date Type Options ──────────────────────────────────────────
export const END_DATE_TYPE_OPTIONS = [
  { value: 'specific', label: 'Specific date' },
  { value: 'end_of_program', label: 'End of program' },
  { value: 'merchant_account_closing', label: 'Merchant account closing' },
] as const
